import React from 'react';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { StyledTag } from './index.style';

const Tag = ({ label, onRemove }) => (
  <StyledTag>
    <Typography variant="body-12-medium" color={COLOR.darkGray}>
      {label}
    </Typography>
    <CloseRoundedIcon
      onClick={onRemove}
      sx={{ color: COLOR.navyBlue, fontSize: '16px', cursor: 'pointer' }}
    />
  </StyledTag>
);

export default Tag;
